/** Temps restant avant une échéance, en heures : « 11h 23min », « 3j 2h » (pages Propositions et tableau de bord). */
export const fmtLeft = (hoursFloat) => {
  const totalMin = Math.floor(hoursFloat * 60);
  const h = Math.floor(totalMin / 60);
  const min = totalMin % 60;
  if (h >= 24) { const d = Math.floor(h / 24); const rh = h % 24; return rh > 0 ? `${d}j ${rh}h` : `${d}j`; }
  return min > 0 ? `${h}h ${min}min` : `${h}h`;
};
